import { Route, Routes } from 'react-router-dom'

import Admin from 'screens/Admin'
import AdminLogs from 'screens/AdminLogs'
import AdminProjectsEditor from 'screens/AdminPageEditor'
import AdminProject from 'screens/AdminProject'
import AdminProjectCover from 'screens/AdminProjectCover'
import AdminProjectCoverEditor from 'screens/AdminProjectCoverEditor'
import AdminProjectExport from 'screens/AdminProjectExport'
import AdminProjectSettings from 'screens/AdminProjectSettings'
import Home from 'screens/Home'
import Export from 'screens/ProjectExport'
import ProjectSettings from 'screens/ProjectSettings'
import YearbookCover from 'screens/YearbookCover'
import YearbookCoverEditor from 'screens/YearbookCoverEditor'
import YearbookEditor from 'screens/YearbookEditor'
import YearbookPages from 'screens/YearbookPages'
import RedirectKeepingUrlParams from 'shared/ui/RedirectKeepingUrlParams'

const Router = () => (
  <Routes>
    {/* <Route path="*" element={<Maintenance />} /> */}

    <Route path="/" element={<Home />}></Route>
    <Route path=":projectId">
      <Route
        index
        element={<RedirectKeepingUrlParams to="content" />}
      />
      <Route path="content" element={<YearbookPages />} />
      <Route path="cover" element={<YearbookCover />} />
    </Route>

    <Route path=":projectId/cover/editor">
      <Route path="inside" element={<YearbookCoverEditor />} />
      <Route path="outside" element={<YearbookCoverEditor />} />
    </Route>

    <Route
      path=":projectId/content/editor/:pageId"
      element={<YearbookEditor />}
    />
    <Route path=":projectId/settings" element={<ProjectSettings />} />
    <Route path=":projectId/settings/export" element={<Export />} />
    <Route path="/admin/*" element={<Admin />} />
    <Route
      path="/admin/projects/:groupId/:projectId/content"
      element={<AdminProject />}
    />
    <Route
      path="/admin/projects/:groupId/:projectId/cover"
      element={<AdminProjectCover />}
    />
    <Route
      path="/admin/projects/:groupId/:projectId"
      element={<AdminProject />}
    />
    <Route path="/admin/old/:projectId" element={<AdminProject />} />
    <Route
      path="/admin/projects/:groupId/:projectId/editor/:pageId"
      element={<AdminProjectsEditor />}
    />
    <Route
      path="/admin/projects/:groupId/:projectId/content/editor/:pageId"
      element={<AdminProjectsEditor />}
    />
    <Route path="/admin/projects/:groupId/:projectId/cover/editor">
      <Route path="inside" element={<AdminProjectCoverEditor />} />
      <Route path="outside" element={<AdminProjectCoverEditor />} />
    </Route>

    <Route
      path="/admin/projects/:groupId/:projectId/settings"
      element={<AdminProjectSettings />}
    />
    <Route
      path="/admin/projects/:groupId/:projectId/settings/export"
      element={<AdminProjectExport />}
    />
    <Route path="/admin/logs" element={<AdminLogs />} />
  </Routes>
)

export default Router
